'use client'

import { Modal } from '@populix/pop-ui'
import Image from 'next/image'
import { IoMdClose } from 'react-icons/io'

type TImageFocusModal = {
  isOpen: boolean
  onClose: () => void
  src: string
  alt: string
}

export default function ImageFocusModal({ isOpen, onClose, src, alt }: Readonly<TImageFocusModal>) {
  return (
    <Modal isOpen={isOpen} disableClose className='max-w-[440px]'>
      <div className='relative z-0 m-0 aspect-square max-h-[400px] w-full max-w-[400px] rounded'>
        <Image src={src} alt={alt} layout='fill' objectFit='contain' />
        <button
          className='absolute right-0 top-0 flex h-8 w-8 cursor-pointer flex-row items-center justify-center rounded-full bg-black opacity-50'
          onClick={onClose}
        >
          <IoMdClose size={24} className='text-white' />
        </button>
      </div>
    </Modal>
  )
}
